import { type Mark } from '#components/Form/RangeSlider/types.ts';
import { Keyword } from '#enums/keywords.ts';
import { keys } from '#helpers/otherHelpers.ts';
import { type Config } from '#types.ts';
import { formatCertifications } from '../CertificationRangeSlider/helpers/formatCertifications.ts';
import { formatGenres } from '../GenreMultiSelectDropdown/helpers/formatGenres.ts';
import { type FiltersResponse, type Option } from '../types.ts';

const formatters = {
  certifications: formatCertifications,
  genres: formatGenres,
};

const keywords = [
  {
    id: Keyword.Anime,
    name: 'Anime',
  },
  {
    id: Keyword.Nature,
    name: 'Nature',
  },
];

export const formatFilterOptions = (
  data: FiltersResponse | undefined,
  config: Config,
): Record<string, Mark[] | Option[]> => {
  if (!data) {
    return {};
  }

  return keys(data).reduce(
    (acc, key) => {
      switch (key) {
        case 'certifications': {
          const formatter = formatters[key];
          const formatted = formatter(data[key], config);

          if (!formatted) {
            return acc;
          }

          return { ...acc, [key]: formatted };
        }

        case 'genres': {
          const formatter = formatters[key];
          const formatted = formatter(data[key]);
          return { ...acc, [key]: formatted };
        }
      }
    },
    { keywords },
  );
};
